import { ServicesModule } from './componets/services/services.module';
import { HomeModule } from './componets/home/home.module';
import { ErrorModule } from './componets/error/error.module';
import { AboutModule } from './componets/about/about.module';
import { BrowserModule, Title } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS
} from "@angular/common/http";

import { AppComponent } from "./app.component";

import { BaseService } from "./Services/Base.service";
import { AppGlobal } from "./app.global";
import { HttpRequestInterceptor } from "./http-request.interceptor";

import { NavComponent } from './componets/share/nav/nav.component';


@NgModule({
  declarations: [
    AppComponent,
    NavComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HomeModule,
    ServicesModule,
    AboutModule,
    ErrorModule,
    HttpClientModule
  ],
  providers: [
    AppGlobal,
    BaseService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
